<div class="flex w-full flex-col items-center space-y-4" style="pointer-events: auto !important">
  <span class="text-2xl font-bold">Add your first Vendor Contract!</span>
  <span class="text-lg">
    Once you have added your Vendor Contracts, you'll be able to easily manage your Vendor Budgets
    in Auxilius.
  </span>
  <div class="flex w-full flex-row items-center justify-center space-x-4">
    <aux-button
      [disabled]="ctx.disabledUI()"
      [auxTooltip]="ctx.vendorActionTooltip()"
      variant="secondary"
      label="Add New Vendor Contract"
      (clickEmit)="onNewVendor(params)"
      icon="Plus"
    />
    <aux-button
      [disabled]="ctx.disabledUI()"
      [auxTooltip]="ctx.vendorActionTooltip()"
      variant="secondary"
      label="Add Multiple Vendor Contracts"
      (clickEmit)="onAddMultipleVendors(params)"
      icon="Plus"
    />
  </div>
</div>
